import { useContext, useEffect, useRef, useState } from "react";
import { useSocket } from "../../../Contexts/WebSocketContext";
import { UserContext } from "../../../Contexts/UserContext";

const AutoGrowingTextarea = ({ placeholder, message, setMessage, slsectedChatSession }) => {
  const textareaRef = useRef(null);
  const { socket, selectedChatSession } = useSocket();
  const { userInfo } = useContext(UserContext);
  const typingTimeout = useRef(null);
  const lastTypedTime = useRef(0);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
    }
  }, [message]);

  const handleInputChange = (e) => {
    setMessage(e.target.value);

    if (!selectedChatSession || !userInfo) return;

    const now = Date.now();
    if (now - lastTypedTime.current > 500) {
      socket.send(JSON.stringify({type: "chat:typing", payload: {
        sessionId: selectedChatSession._id,
        userId: userInfo._id,
        isTyping: true,
      }}));
      lastTypedTime.current = now;
    }

    if (typingTimeout.current) {
      clearTimeout(typingTimeout.current);
    }

    typingTimeout.current = setTimeout(() => {
      socket.send(JSON.stringify({type: "chat:typing", payload:{
        sessionId: selectedChatSession._id,
        userId: userInfo._id,
        isTyping: false,
      }}));
    }, 3000);
  };

  return (
    <textarea
      ref={textareaRef}
      value={message}
      placeholder={placeholder}
      onChange={handleInputChange}
      rows={1}
      autoComplete="off"
      autoCorrect="off"
      spellCheck={false}
      id="message-box-42"
      style={{
        resize: "none",
        overflow: "hidden",
        width: "100%",
        minHeight: "16px",
      }}
      disabled={!!document.getElementsByClassName("inbox-no-chat-selected")[0] || selectedChatSession?.status !== "active"}
    />
  );
};

export default AutoGrowingTextarea;
